import classNames from 'classnames'
import TextBodySmaller from 'components/TextBodySmaller'
import { MESSAGE_TYPE_TO_COLOR } from 'constants/message'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { logUtil } from 'packages/src'
import { usePreviousHookUtil } from 'modules/component/utils/hooks/usePrevious.js'

/**
 * @param value
 * @param placeholder
 * @param name
 * @param onChange
 * @param colorType
 * @param color
 * @param onBlur
 * @param hasLetterCount
 * @param style
 * @param containerStyle
 * @returns {Element}
 * @constructor
 */
export default function Textarea ({
  value,
  placeholder,
  name,
  onChange,
  colorType,
  color,
  onBlur,
  hasLetterCount,
  style,
  containerStyle,
  isFocused: initialIsFocused = false
}) {
  const [valueLocal, setValueLocal] = React.useState(value)
  const ref = React.useRef()

  const [isFocused, setIsFocused] = React.useState(initialIsFocused)
  const prevIsFocused = usePreviousHookUtil(isFocused)

  const focus = () => {
    if (!ref.current) {
      logUtil('Textarea#focus').debug('[noop] no ref')
      return
    }

    if (props.isSelectedOnFocus) {
      logUtil('Textarea#focus').debug('[input][select]')
      ref.current.select()
      return
    }

    logUtil('Textarea#focus').debug('[done]')
    ref.current.focus()
  }

  React.useEffect(() => {
    if (!prevIsFocused && isFocused) {
      focus()
    }
  }, [
    prevIsFocused,
    isFocused
  ])

  const triggerFocus = () => {
    logUtil('Textarea#triggerFocus').debug('[start]')
    setIsFocused(true)
    // onFocus?.(props.name)
  }

  const handleFocus = () => {
    logUtil('Textarea#handleFocus').debug('[start]')
    triggerFocus()
  }

  const handleChange = (event) => {
    event.stopPropagation()
    const value = event.target.value
    setValueLocal(value)
    if (onChange) {
      onChange(event, name, value)
    }
  }

  const getBorderColor = () => {
    const borderColor = MESSAGE_TYPE_TO_COLOR[colorType]
    if (borderColor) {
      return borderColor
    }
    if (color && color !== STYLES_COLOR.BLACK) {
      return color
    }
    return STYLES_COLOR.GREY_MEDIUM
  }

  const className = classNames({
    textarea: true
  })

  const props = {
    className: 'textarea-field',
    name,
    value: valueLocal,
    placeholder,
    onChange: handleChange.bind(this)
  }
  return (
    <div
      className={className}
      style={containerStyle}
    >
      <textarea
        ref={ref}
        {...props}
        onBlur={onBlur}
        onFocus={handleFocus}
        style={{
          border: `0.055em solid ${getBorderColor()}`,
          padding: '1.33em',
          height: '20em',
          width: '100%',
          boxSizing: 'border-box',
          overflowY: 'scroll',
          ...(style || {})
        }}
      />

      {
        valueLocal &&
        hasLetterCount && (
          <TextBodySmaller>
            {valueLocal.length}
          </TextBodySmaller>
        )
      }
    </div>
  )
}
